import React from 'react';
import { Box, Button, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { AccountData, OrderPageData } from '../../../api';
import { useStartingPriceLabel } from '../../common/storefrontPriceUtils';

interface MobileBookingBarProps {
  orderPage: OrderPageData;
  account: AccountData;
  onBookNowClick: () => void;
  isTrial?: boolean;
}

export const MobileBookingBar = ({ orderPage, account, onBookNowClick, isTrial }: MobileBookingBarProps) => {
  const { t } = useTranslation();
  const { label: priceLabel, startingPrice } = useStartingPriceLabel(orderPage, account);

  return (
    <Box
      sx={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        backgroundColor: 'white',
        borderTop: '1px solid #e0e0e0',
        boxShadow: '0 -4px 12px rgba(0,0,0,0.1)',
        zIndex: 1100,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: 1,
        paddingX: 2,
        paddingY: 1.5,
      }}>
      {startingPrice > 0 && (
        <Typography variant="h6" sx={{ fontWeight: 700, lineHeight: 1.2 }}>
          {priceLabel}
        </Typography>
      )}

      <Button
        variant="contained"
        onClick={onBookNowClick}
        sx={{
          paddingY: 1.5,
          paddingX: 4,
          fontWeight: 600,
          fontSize: '1rem',
        }}>
        {t(isTrial ? 'experiencePage.bookYourTrial' : 'experiencePage.bookNow')}
      </Button>
    </Box>
  );
};
